import React from "react";
import { createRoot } from "react-dom/client";

import App from "./app";
import { redirectToHubDomain } from "./lib/domain-redirects";
import { I18n } from "./lib/i18n";
import { makeReactRootErrorHandler } from "./lib/contexts/web-analytics";
import stylesheet from "./styles/index.scss?url";

import "./styles/fonts/fira";
// @ts-expect-error this is a sideeffect import for bundling
import "./styles/fonts/fira/as-default.css";
// @ts-expect-error this is a sideeffect import for bundling
import "./styles/print.scss";

import "./setup-dayjs";

redirectToHubDomain();

const reportReactError = makeReactRootErrorHandler();
const root = createRoot(document.getElementById("root")!, {
  onCaughtError: reportReactError,
  onUncaughtError: reportReactError,
});

root.render(
  <I18n>
    <link rel="stylesheet" precedence="shell" href={stylesheet} />
    <App />
  </I18n>
);

export { Highchart } from "./lib/chart";
export { organizationName } from "./lib/contexts/organization";
export { useOrganization } from "./lib/contexts/organization";
export { addIf } from "./lib/util";
